var _defs, _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCoinmarketcap = function SvgCoinmarketcap(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1646118379309,
    className: "icon",
    viewBox: "0 0 1024 1024",
    "p-id": 2685,
    width: 200,
    height: 200,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M512 93.44c-227.2768 0-412.2624 187.7504-412.2624 418.56s184.8832 418.56 412.2624 418.56A407.7568 407.7568 0 0 0 792.2176 819.2a38.4512 38.4512 0 0 0 1.9968-53.76 37.12 37.12 0 0 0-52.4288-2.56l-0.5632 0.512A333.5168 333.5168 0 0 1 261.12 740.4544l175.872-282.6752v130.304c0 62.6176 24.2688 82.8416 44.5952 88.7808s51.5072 1.8432 84.224-51.2l96.8192-156.9792c3.1232-5.12 5.9392-9.4208 8.6016-13.2096v79.4112c0 58.5216 23.3984 105.3184 64.256 128.3584a117.76 117.76 0 0 0 120.8832-5.12c45.7216-28.8768 70.3488-81.92 67.7888-146.2784v-1.8944c-1.0752-229.7856-185.5488-416.512-412.16-416.512zM816.7424 593.92a43.9808 43.9808 0 0 1-44.8512 3.0208c-16.5888-9.3696-25.6-31.3344-25.6-61.8496V443.4944c0-44.0832-17.4592-75.4688-46.592-83.968-49.408-14.3872-86.5792 46.08-100.5568 68.7616l-87.04 141.312V396.9024c-0.9728-39.7312-13.8752-63.488-38.3488-70.656-16.2304-4.7104-40.4992-2.816-64.0512 33.2288l-195.4304 313.4464A344.8832 344.8832 0 0 1 174.592 512c0-188.8256 151.3472-342.4256 337.3056-342.4256s337.3056 153.6 337.3056 342.4256v0.9216a5.5296 5.5296 0 0 0 0 0.9216c1.8432 36.5568-9.984 65.6896-32.4608 80.0768z",
    fill: "#3487A1",
    "p-id": 2686
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCoinmarketcap, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/coinmarketcap.1d7e6b09.svg";
export { ForwardRef as ReactComponent };